import { Appointment } from "Types/api/Appointment";
import { CurrentDealAppointment } from "Types/state";
import { REMOVE_SCHEDULE_APPOINTMENT, UPDATE_CURRENT_DEAL, UPDATE_SCHEDULE_APPOINTMENT } from "../constants";

export interface UpdateCurrentDealAction {
    data: { vin: string };
    type: UPDATE_CURRENT_DEAL;
}

export function updateCurrentDeal(vin: string): UpdateCurrentDealAction {
    return {
        data: { vin },
        type: UPDATE_CURRENT_DEAL,
    };
}

export interface UpdateScheduleAppointmentAction {
    data: CurrentDealAppointment;
    type: UPDATE_SCHEDULE_APPOINTMENT;
}

export function updateScheduleAppointment(date: Date, time: Appointment["time"]): UpdateScheduleAppointmentAction {
    return {
        data: {
            date,
            time,
        },
        type: UPDATE_SCHEDULE_APPOINTMENT,
    };
}

export interface RemoveScheduleAppointmentAction {
    type: REMOVE_SCHEDULE_APPOINTMENT;
}

export function removeScheduleAppointment(): RemoveScheduleAppointmentAction {
    return {
        type: REMOVE_SCHEDULE_APPOINTMENT,
    };
}
